<template>
  <section v-if="dados" class="suporte">
    <HeroResponsivo
      :desktopSrc="dados.imagemDesktop"
      :mobileSrc="dados.imagemMobile || dados.imagemDesktop"
      alt="Central de Suporte Click Sorvetes"
    />

    <section class="conteudo container">
      <header class="header">
        <h1 class="titulo">
          <span>{{ dados.tituloDestaque }}</span> {{ dados.tituloPrincipal }}
        </h1>
        <p class="subtitulo">{{ dados.subtitulo }}</p>
      </header>

      <div v-if="listaItens?.length" class="cards-container">
        <SuporteComponent
          v-for="item in listaItens"
          :key="item.id"
          v-bind="item"
        />
      </div>
    </section>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import HeroResponsivo from "@/components/HeroResponsivo.vue";
import SuporteComponent from "@/components/SuporteComponent.vue";
import { getJson } from "@/utils";

/* === Estados === */
const dados = ref(null);
const listaItens = ref([]);

/* === Carregamento === */
onMounted(async () => {
  try {
    dados.value = await getJson("suporte/suporte.json");
    listaItens.value = await getJson("suporte/SuporteHome.json");
  } catch (err) {
    console.error("❌ Erro ao carregar dados da página de suporte:", err.message);
  }
});
</script>

<style scoped>
/* ==========================================================
   BASE GERAL
   ========================================================== */
.suporte {
  background-color: var(--branco);
  color: var(--cinza-escuro);
  font-family: var(--fonte-base);
  border-top: 4px solid var(--amarelo-principal);
  padding-bottom: 90px;
  overflow-x: hidden;
}

/* ==========================================================
   CONTEÚDO PRINCIPAL
   ========================================================== */
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: 1200px;
  margin: 80px auto;
  padding: 0 1rem;
}

.header {
  width: 100%;
  margin-bottom: 3rem;
}

.titulo {
  font-size: 2.4rem;
  font-weight: 800;
  color: #222;
  margin-bottom: 1.2rem;
  line-height: 1.3;
}

.titulo span {
  color: var(--rosa-principal);
}

.subtitulo {
  font-size: 1.05rem;
  color: #555;
  line-height: 1.7;
  margin: 0 auto 2rem auto;
  max-width: 700px;
  text-align: center;
}

/* ==========================================================
   GRID DE CARDS
   ========================================================== */
.cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1rem;
}

/* ==========================================================
   RESPONSIVIDADE
   ========================================================== */
@media (max-width: 900px) {
  .titulo {
    font-size: 2rem;
  }

  .subtitulo {
    font-size: 1rem;
  }

  .cards-container {
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .conteudo {
    margin-top: 50px;
    margin-bottom: 40px;
    padding: 0 1rem;
  }

  .titulo {
    font-size: 1.8rem;
    line-height: 1.3;
    margin-bottom: 0.8rem;
  }

  .subtitulo {
    font-size: 0.95rem;
    line-height: 1.6;
    color: #666;
    margin: 0 auto 1.8rem auto;
    text-align: center;
  }

  .cards-container {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
}
</style>
